import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from "react-router-dom"
import { signinRedirectCallback } from '../../../../redux/actions/auth'
import UserRoles from '../../../../constants/UserRoles'
import LoadingBlock from '../../../common/LoadingBlock'
import ApiBuilder from '../../../../services/ApiBuilder'
import './style.sass'

const SigninCallback = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const isProcessingSigninCallback = useSelector(({ auth }) => auth.isProcessingSigninCallback)
  
  useEffect(() => {
    const init = async () => {
      const res = await dispatch(signinRedirectCallback())

      // Setting access token
      ApiBuilder.setAccessTokenToHeader(res?.access_token)

      // Redirecting
      const isAdmin = res?.profile?.role?.includes(UserRoles.SYSTEM_ADMIN)
      if (res && isAdmin) {
        history.push("/admin/dashboard") // TODO - Redirect to page user came from
      }else if(res){
        history.push("/partner/dashboard") // Normal user
      }
    }
    init()
  }, [])

  return (
    <div className="signin-callback-container">
      {isProcessingSigninCallback && (
        <LoadingBlock message="Loading, please wait..." />
      )}
    </div>
  )
}

export default SigninCallback